import { createContext } from 'react'
import type { StartTourOptions, TourDefinition, TourStep } from './types'

export interface TourGuideContextValue {
  activeTour: TourDefinition | null
  currentStep: TourStep | null
  currentStepIndex: number
  isTourActive: boolean
  isNextEnabled: boolean
  startTour: (id: string, options?: StartTourOptions) => boolean
  previousStep: () => void
  nextStep: () => void
  endTour: () => void
  skipTour: () => void
}

export const TourGuideContext = createContext<TourGuideContextValue | undefined>(undefined)
